module.exports = __webpack_public_path__ + "assets/bad_feedback.94f4309b.svg";